import { Routes, Route } from 'react-router-dom';
import { Overview } from './services/Overview';
import { TraumaticBrainInjuries } from './services/TraumaticBrainInjuries';
import { Dysautonomia } from './services/Dysautonomia';
import { Headaches } from './services/Headaches';
import { FND } from './services/FND';
import { Neurodevelopmental } from './services/Neurodevelopmental';
import { MovementDisorders } from './services/MovementDisorders';

export function Services() {
  return (
    <Routes>
      <Route index element={<Overview />} />
      <Route path="traumatic-brain-injuries" element={<TraumaticBrainInjuries />} />
      <Route path="dysautonomia" element={<Dysautonomia />} />
      <Route path="headaches" element={<Headaches />} />
      <Route path="fnd" element={<FND />} />
      <Route path="neurodevelopmental" element={<Neurodevelopmental />} />
      <Route path="movement-disorders" element={<MovementDisorders />} />
    </Routes>
  );
}